import React from "react";

const FooterAccessibilityLink = () => {
	return (
		<a href="https://www.msd.com:443/our-commitment-to-accessibility-for-all/">
			Acessibilidade
		</a>
	);
};

export default FooterAccessibilityLink;
